import { Card, Bleed, Divider, InlineStack, Icon, Popover, Text, BlockStack } from "@shopify/polaris";
import { ChevronDownMinor } from "@shopify/polaris-icons";
import React from "react";
import { useState } from "react";
import { DI, DIProps } from "../../../../Core";
import { getTotalPrice } from "../Utils/Helper";
import { useTranslation } from "react-i18next";

interface props extends DIProps {
    row: any
}
const RenderOrderItems = (props: props) => {
    const { t } = useTranslation();
    const { row } = props;
    const [popoverActive, setPopoverActive] = useState<boolean>(false);

    return (
        <InlineStack gap="200" blockAlign='center'>
            <Text as="p">{`${row?.items?.length ?? 0} item${row?.items?.length > 1 ? "s" : ""}`}</Text>
            <Popover
                active={popoverActive}
                preferredAlignment="right"
                activator={<div style={{ cursor: 'pointer' }} onClick={() => setPopoverActive(!popoverActive)}> <Icon source={ChevronDownMinor} tone="subdued" /></div>}
                autofocusTarget="first-node"
                onClose={() => setPopoverActive(!popoverActive)}
            >
                <Card padding='300'>
                    <BlockStack gap="400">
                        {
                            row?.items && row?.items?.map((item: any, idx: number) => {
                                return (
                                    <React.Fragment key={idx}>
                                        <BlockStack gap="200">
                                            <InlineStack blockAlign='center' align="space-between" gap="300">
                                                <div style={{ maxWidth: "250px" }}>
                                                    <Text as='p' variant="bodySm" fontWeight="semibold" breakWord>{item?.title}</Text>
                                                </div>
                                                {item?.qty && <Text as='span' variant="bodySm">x{item?.qty}</Text>}
                                            </InlineStack>
                                            <Text as='p' tone="subdued" variant="bodySm">Price: {getTotalPrice(row)}</Text>
                                        </BlockStack>
                                        {idx < row?.items?.length - 1 && <Bleed><Divider /></Bleed>}
                                    </React.Fragment>
                                )
                            })
                        }
                    </BlockStack>

                </Card>
            </Popover>
        </InlineStack>
    )
}

export default DI(RenderOrderItems);